<template>
  <div class="w-full md:relative bg-[#fcc91e] lg:bg-opacity-95">
    <div class="w-full hidden md:block relative -z-10">
      <img
        src="@/assets/LPnew/images/banner.webp"
        alt=""
        class="w-full h-[680px] md:h-[850px] lg:h-[650px]"
      />
    </div>

    <div class="">
      <div class="md:absolute top-0 w-full">
        <div class="px-5 lg:px-8">
          <div class="max-w-7xl mx-auto relative">
            <header class="header">
              <div class="">
                <div class="py-5">
                  <div
                    class="flex justify-around md:justify-between items-center"
                  >
                    <div class="">
                      <img
                        class="w-[160px] sm:w-[175px] h-[33px] md:w-[455px] md:h-[80px]"
                        src="@/assets/LPnew/images/Jain-Online-Logo.webp"
                        alt="logo"
                      />
                    </div>
                    <div>
                      <span
                        ><a
                          href="tel:+919294939295"
                          class="w-[100px] h-[39px] bg-[#001C54] text-white px-1 md:px-5 py-2 text-[12px] md:text-xl rounded-3xl"
                          >+91-9294939295</a
                        >
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <!-- banner -->
            <div class="h-[500px] lg:h-[528px] pt-0 md:pt-16">
              <div
                class="flex flex-col lg:flex-row justify-between items-center"
              >
                <div class="flex flex-col gap-3">
                  <div class="text-center md:text-left">
                    <div class="font-bold text-lg xl:text-2xl text-black">
                      Uplift your Career with
                    </div>
                    <div
                      class="font-extrabold text-2xl md:text-2xl xl:text-4xl text-black xl:w-max mb-0 md:mb-4"
                    >
                      Online Degree Programs
                    </div>
                  </div>

                  <div
                    class="text-left text-[14px] bg-[#001c54] flex flex-wrap justify-center p-2 text-white font-bold"
                  >
                    <span class="pr-2 border-r-2 mr-2 text-sm xl:text-xl"
                      >MBA</span
                    ><span class="pr-2 pl-2 border-r-2 mr-2 text-sm xl:text-xl"
                      >MCA</span
                    ><span class="pr-2 pl-2 border-r-2 mr-2 text-sm xl:text-xl"
                      >M.COM</span
                    ><span class="pr-2 border-r-2 pl-2 mr-2 text-sm xl:text-xl"
                      >MA</span
                    >
                    <span class="pr-2 border-r-2 pl-2 mr-2 text-sm xl:text-xl"
                      >BBA</span
                    ><span class="pr-2 pl-2 mr-2 text-sm xl:text-xl"
                      >B.COM</span
                    >
                  </div>
                  <div class="mt-0 md:mt-5 px-3 hidden lg:block">
                    <img
                      src="@/assets/LPnew/images/UGC-logo.webp"
                      alt=""
                      srcset=""
                      class="w-[auto] text-center md:w-[100%] h-[auto]"
                    />
                  </div>
                </div>

                <!-- image -->
                <div class="hidden lg:block absolute bottom-0 left-[37%]">
                  <img
                    src="@/assets/LPnew/images/bnrThub.png"
                    alt=""
                    srcset=""
                    class="w-[300px] xl:w-full"
                  />
                </div>
                <!-- enquire form -->
                <div
                  class="bg-[#f8f0d8] w-[340px xl:w-[300px] 2xl:w-[340px] h-[150px] mt-14"
                >
                  <div
                    class="flex justify-center flex-col p-4 text-start font-bold"
                  >
                    <div class="text-2xl text-center">
                      Thank you for your Enquiry.
                    </div>
                    <div class="text-center">
                      Someone from our team will be in touch with you shortly.
                    </div>
                  </div>
                </div>
                <!--Enquire form -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-[#062051] px-8 py-6 lg:py-12 xl:py-6">
      <div class="max-w-7xl mx-auto">
        <div
          class="flex flex-wrap justify-center md:justify-start gap-2 lg:justify-between items-center md:h-[180px]"
        >
          <div class="flex flex-col gap-4 w-[140px] md:w-[200px]">
            <p
              class="text-2xl lg:text-4xl font-extrabold text-center text-[#FDD024]"
            >
              40+
            </p>
            <p class="text-white text-[14px] lg:text-[20px]">
              In Demand Electives
            </p>
          </div>
          <div class="flex flex-col gap-4 w-[140px] md:w-[200px]">
            <p class="text-2xl lg:text-4xl font-extrabold text-[#FDD024]">
              2,000+
            </p>
            <p class="text-white text-[14px] lg:text-[20px]">
              Hiring Corporates
            </p>
          </div>
          <div class="flex flex-col gap-4 w-[140px] md:w-[200px]">
            <p class="text-2xl lg:text-4xl font-extrabold text-[#FDD024]">
              20,000+
            </p>
            <p class="text-white text-[14px] lg:text-[20px]">
              Courses on LinkedIn Learning
            </p>
          </div>
          <div class="flex flex-col gap-4 w-[140px] md:w-[200px]">
            <p class="text-2xl lg:text-4xl font-extrabold text-[#FDD024]">
              0% Cost
            </p>
            <p class="text-white text-[14px] lg:text-[20px]">EMI Option</p>
          </div>
          <div class="flex flex-col gap-4 w-[140px] md:w-[200px]">
            <p class="text-2xl lg:text-4xl font-extrabold text-[#FDD024]">
              NAAC A++
            </p>
            <p class="text-white text-[14px] lg:text-[20px]">Accredited</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from "@unhead/vue";
export default {
  name: "BannerView",
  data() {
    return {};
  },
  created() {},
  methods: {},
  mounted() {
    useHead({
      meta: [{ name: "robots", content: "noindex" }],
    });

    // Google Tag Manager conversion event
    // gtag("event", "conversion", {
    //   send_to: "AW-413149258/X8diCMKa74oYEMrQgMUB",
    // });
  },
};
</script>

<style></style>
